import { from } from 'rxjs'
import { switchMap, filter } from 'rxjs/operators'
import Actions from '../actions'
import { getPayload } from '../utils/rxUtils'
import { setLocale } from '../i18n'

export const changeLocale = action$ => {
  return action$.pipe(
    getPayload(Actions.CHANGE_LOCALE_REQUESTED),
    filter(({ locale }) => locale),
    switchMap(({ locale }) => {
      return setLocale(locale)
    }),
    switchMap(locale =>
      from([
        Actions.createAction(Actions.CHANGE_LOCALE_RECEIVED, {
          locale
        })
      ])
    )
  )
}
